import { HttpClient } from '@angular/common/http';
import { Base } from './base';

export class Ips extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'ips');
  }

  getCountryCode() {
    return this.api.get('country_code');
  }
}
